import {noop} from 'lodash';
import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {OnboardingDataEventObject} from '../../../../../libs/shared/core/src/models/tracking/objectNames/onboardingDataEventObject';
import {InfoBubblePillVariantsEnum} from '../../../common/infoBubbles/infoBubblePill';
import {EducationTip} from '../../../educationTips/educationTip';
import {generateStepText} from '../../welcome/onboardingWelcomeHelpers';
import {SandboxEducationTipProps} from './sandboxEducationTip';

/*
 * Component.
 */

export const AnalyticsIntroEducationTip: FC<SandboxEducationTipProps> = (props) => (
  <EducationTip
    anchor={props.anchor}
    position="left"
    isVisible={props.isVisible}
    isStandalone
    onRequestClose={noop}
    pillType={InfoBubblePillVariantsEnum.EDUCATION}
    title={
      <Trans id="infobubble-onboarding-analytics-intro-title">Scroll for example analytics reports</Trans>
    }
    primaryActionLabel={<Trans id="infobubble-onboarding-analytics-intro-primary">Next</Trans>}
    stepCounter={generateStepText(1, 2)}
    dataObjectName={OnboardingDataEventObject.DEMO_ANALYTICS_INTRO}
    onPrimaryClick={props.onNextClick}
  >
    <Trans id="infobubble-onboarding-analytics-intro-description">
      Track metrics on team performance, conversation&nbsp;trends, customer satisfaction, and more to make
      data-driven decisions.
    </Trans>
  </EducationTip>
);
